import React, { PropsWithChildren } from 'react'
import classNames from 'classnames'

interface Props extends PropsWithChildren {
  className?: string
}

export const GradientWrapper = ({ className, children }: Props) => {
  return (
    <div
      className={classNames('overflow-hidden p-[1px]', className)}
      style={{
        background:
          'linear-gradient(156.52deg, rgba(255, 255, 255, 0.3) 2.12%, rgba(255, 255, 255, 0.0001) 39%, rgba(255, 255, 255, 0.0001) 54.33%, rgba(255, 255, 255, 0.1) 93.02%)',
      }}
    >
      {children}
    </div>
  )
}
